export default __webpack_public_path__ + "static/media/check.a4e2195c.svg";